import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone, faCircleNotch, faHeadset} from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Bar from "../components/chart/Bar";
import Select from "react-select";
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { useLocation } from 'react-router-dom';
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { Link } from "react-router-dom";
import { set } from "date-fns";

const marks = [
  {
    value: 0,
    label: '0',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 20,
    label: '20',
  },
  {
    value: 30,
    label: '30',
  },
  {
    value: 40,
    label: '40',
  },
    {
    value: 50,
    label: '50',
  },
  {
    value: 60,
    label: '60',
  },
  {
    value: 70,
    label: '70',
  },
  {
    value: 80,
    label: '80',
  },
  {
    value: 100,
    label: '100',
  },
];
function valuetext(value) {
  return `${value}`;
}
function LoanForm() {
  const { user } = useUser();
  const { state } = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const darkThemeStyles1 = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "rgb(30, 33, 36)",
      border: "none",
      color: "#fff",
      fontWeight: '600',
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "rgb(30, 33, 36)",
      fontWeight: '600',
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "#151719" : isFocused ? "#151719" : "rgb(30, 33, 36)",
      color: "#fff",
      fontWeight: '600',
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
      fontWeight: '600',
    }),
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
    const r = await getRate(currencyCode);
    if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [loanDetails, setLoanDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [disable, setDisable] = useState(true);
  useEffect(() => {
    if (!state) return;
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchsoffer: true, loan_id:state.loan_id })
    })
    .then(response => response.json()) 
    .then(data => {
        setLoanDetails(data.offer);
        setLoading(false);
    })
    .catch(err => {
        window.location.href = '/loan';
    })
  }, [state]);
  const [assethistory, setAssethistory] = useState([]);
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [wallet, setWallet] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWallet(data.wallet);
      }
    })
    .catch(err => {
      
    })
  }, [user]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const walletMap = wallet.reduce((acc, item) => {
      const key = item.coinName?.trim().toLowerCase();
      acc[key] = parseFloat(item.balance) || 0;
      return acc;
    }, {});
    const applyWalletBalance = (list, categoryTotal) => {
      let categorySum = 0;
      const result = list.map(item => {
        const key = item.name?.trim().toLowerCase();
        const matchedBalance = walletMap[key];
        const amount = matchedBalance || 0;
        const value = amount * item.price;
        categorySum += value;
        return {
          ...item,
          amount: matchedBalance || 0
        };
      });
      return { result, categorySum };
    };
    const { result: cryptoWithBalance } = applyWalletBalance(crypto);
    const { result: fiatWithBalance } = applyWalletBalance(fiat);
    const { result: stockWithBalance } = applyWalletBalance(stock);
    const merged = [
      ...cryptoWithBalance,
      ...fiatWithBalance,
      ...stockWithBalance
    ];
    const sorted = merged.sort((a, b) => {
      if (b.amount > 0 && a.amount === 0) return 1;
      if (a.amount > 0 && b.amount === 0) return -1;
      return a.name.localeCompare(b.name);
    });
    const allAssets = [];
    sorted.forEach(coin => {
      allAssets.push({
        value: coin.name,
        label: <><img src={coin.logo} alt={coin.symbol} width="20" /> {coin.symbol}</>,
        id: coin.id,
        logo: coin.logo,
        name: coin.name,
        symbol: coin.symbol,
        type: coin.type,
        price: coin.price,
        amount: coin.amount
      });
    });
    setAssethistory(allAssets);
  }, [crypto, fiat, stock, wallet]);
  const [loanData, setLoanData] = useState([]);
  const [error, setError] = useState(false);
  //FORM DATA//
  //FORM DATA//
  //FORM DATA//
  const [loanasset, setLoanAsset] = useState();
  const [loan, setLoan] = useState();
  const [loanUsd, setLoanUsd] = useState();
  const [cprice, setCprice] = useState(0);
  const [price, setPrice] = useState(0);
  const [ltv, setLtv] = useState(30);
  useEffect(() => {
    if(loanasset && loan && loanUsd && ltv && !error){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [loanasset, loan, loanUsd, ltv, error]);
  useEffect(() => {
    if(state && assethistory){
      const cprice = assethistory.find((opt) => opt.value === state.casset);
      setCprice(cprice.price);
    }
  }, [state, assethistory]);
  //FORM DATA//
  //FORM DATA//
  //FORM DATA//

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchloan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoanData(data.countedloan);
      }
    })
    .catch(err => {
    })
  }, [user]);
  function validateLoan(value){
    setLoan(value);
    const asset = assethistory.find((opt) => opt.value === loanasset);
    if(asset){
      setPrice(asset.price);
    }
    const AmntUSD = asset ? Number(asset.price) * value : 0;
    setLoanUsd(AmntUSD);
    if(AmntUSD > Number(state.collateral > 0 ? (state.collateral * cprice)*3 : loanDetails.max) || AmntUSD < Number(state.collateral > 0 ? 1 : loanDetails.min)){
      setError(true);
    }else{
      setError(false);
    }
  }
  const [chartData, setChartData] = useState({
    labels: [],
    data: []
  });
  const processLoanDataByMonth = (loans) => {
    const monthlyData = {};
    loans.forEach(loan => {
      const loanDate = new Date(loan.date);
      const monthKey = `${loanDate.getFullYear()}-${String(loanDate.getMonth() + 1).padStart(2, '0')}`;
      if (!monthlyData[monthKey]) {
        monthlyData[monthKey] = 0;
      }
      const asset = assethistory.find(asset => asset.name === loan.method);
      let price = 1;
      if (asset) {
        price = asset.price;
      }
      monthlyData[monthKey] += ((parseFloat(loan.amount.replace(/,/g, '')) * price) * rate).toFixed(2);
    });
    const labels = [];
    const data = [];
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 7);
    for (let i = 0; i < 8; i++) {
      const monthKey = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
      labels.push(formatMonth(currentDate));
      data.push(monthlyData[monthKey] ? Number(monthlyData[monthKey]).toFixed(2) || 0 : 0);
      currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return { labels, data };
  };
  const formatMonth = (date) => {
    const options = { month: 'short' };
    return new Intl.DateTimeFormat('en-US', options).format(date);
  };
  useEffect(() => {
    const { labels, data } = processLoanDataByMonth(loanData);
    setChartData({ labels, data });
  }, [loanData]);
  const convertToDays = (period, qty) => {
    const map = { y: 356, m: 30, w: 7, d: 1 };
    const base = map[String(period)] || 'Year';
    return (qty * base);
  };
  if(!state &&(!loanDetails ||(Array.isArray(loanDetails) && loanDetails.length === 0))){
    setLoading(false);
  }
  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Loan" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Loan" icon={<FontAwesomeIcon icon={faClone} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-lg-6"> 
                <div className="mycard mt-2 d-flex align-items-center">
                  <div className="rounded-circle overflow-hidden d-flex align-items-center justify-content-center" style={{height:'75px',width:'75px'}}>
                    <img src={`/uploads/${loanDetails.photo}`} alt="profile" className="w-100 h-100" style={{objectFit: 'cover'}}/>
                  </div>
                  <div className="ms-3">
                    <p className="fw-bold text-white fw-bold mb-0 text-uppercase">{loanDetails.title}</p>
                    <p className="text-secondary fw-semibold mb-0" style={{fontSize:'14px'}}>Rate: {loanDetails.rate}%</p>
                    <p className="text-secondary fw-semibold mb-0" style={{fontSize:'14px'}}>Range: {getCurrencySymbol(user?.currency)}
                      {formatCurrency(state.collateral > 0 ? 1 : loanDetails.min * rate)} - {getCurrencySymbol(user?.currency)}{formatCurrency(state.collateral > 0 ? ((state.collateral*3)*cprice) * rate : loanDetails.max * rate)}
                    </p>
                  </div>
                </div>
                <div className="mycard shadow p-3 mt-2 position-relative d-none d-md-block" style={{border:'1px solid #ffffff17'}}>
                  <div style={{width:'70%'}}>
                    <h4 className="mb-4 fw-bold">Looking to Finance Your Next Move?</h4>
                    <p className="text-secondary mb-4">Explore flexible home and personal loan options tailored to your needs—competitive rates, clear terms, and fast approvals.</p>
                    <h4 className="mb-0 fw-bold">Need Help?</h4>
                    <p className="mb-0 text-prime mt-2" style={{fontSize:'14px'}}><FontAwesomeIcon className="text-prime me-1" icon={faHeadset} /> Contact our Support</p>
                  </div>
                  <img src="./uploads/partner.png" alt="image" className="position-absolute" style={{width:'25%', bottom:'10px', right:'20px'}}/>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mycard mt-2">
                  <div className="row">
                    <div className="col-12">
                      <h5 className="mb-0 fw-bold mb-4">Loan Amount</h5>
                      <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
                        <input 
                          type="text" 
                          placeholder="0.0000" 
                          className="inputNone"
                          value={loan}
                          onChange={(e) => {validateLoan(e.target.value);}}
                        />
                        <Select
                          options={assethistory} 
                          value={assethistory.find((opt) => opt.value === loanasset)}
                          onChange={(selectedOption) => {setLoanAsset(selectedOption.value);}}
                          isSearchable
                          styles={darkThemeStyles1}
                          className="w-full"
                        />
                      </div>
                      {error && (
                        <p className="mb-0 text-danger fs-7 mt-1">Loan amount must be between {getCurrencySymbol(user?.currency)}{formatCurrency(state.collateral > 0 ? 1 : loanDetails.min * rate)} and {getCurrencySymbol(user?.currency)}{formatCurrency(state.collateral > 0 ? ((state.collateral*3)*cprice) * rate : loanDetails.max * rate)}</p>
                      )}
                    </div>
                    <div className="col-12">
                      <h5 className="fw-bold my-3">Loan Rate</h5>
                      <div className="d-flex align-items-center w-100 mb-3" style={{gap:'10px', overflowX: 'auto', cursor:'pointer'}}>
                        <div className="rounded-2 px-md-3 px-2 py-2" style={{ width: '100%', minWidth: '20%', backgroundColor: ltv === 50 ? '#ff5213ff' : '#ffffff1c' }} onClick={() => { setLtv(50); }}>
                          <h4 className="mb-0 fw-bold">{((50/convertToDays(loanDetails.period, loanDetails.duration)) * Number(loanDetails.rate)).toFixed(2)}%</h4>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>50 Days</p>
                        </div>
                        <div className="rounded-2 px-md-3 px-2 py-2" style={{ width: '100%', minWidth: '20%', backgroundColor: ltv === 30 ? '#ff5213ff' : '#ffffff1c' }} onClick={() => { setLtv(30); }}>
                          <h4 className="mb-0 fw-bold">{((30/convertToDays(loanDetails.period, loanDetails.duration)) * Number(loanDetails.rate)).toFixed(2)}%</h4>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>30 Days</p>
                        </div>
                        <div className="rounded-2 px-md-3 px-2 py-2" style={{ width: '100%', minWidth: '20%', backgroundColor: ltv === 60 ? '#ff5213ff' : '#ffffff1c' }} onClick={() => { setLtv(60); }}>
                          <h4 className="mb-0 fw-bold">{((60/convertToDays(loanDetails.period, loanDetails.duration)) * Number(loanDetails.rate)).toFixed(2)}%</h4>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>60 Days</p>
                        </div>
                        <div className="rounded-2 px-md-3 px-2 py-2" style={{ width: '100%', minWidth: '20%', backgroundColor: ltv === 180 ? '#ff5213ff' : '#ffffff1c' }} onClick={() => { setLtv(180); }}>
                          <h4 className="mb-0 fw-bold">{((180/convertToDays(loanDetails.period, loanDetails.duration)) * Number(loanDetails.rate)).toFixed(2)}%</h4>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>180 Days</p>
                        </div>
                      </div>
                      <p className="mb-0 fw-bold">Period (days)</p>
                      <Box sx={{ width: '100%', paddingLeft:'10px', paddingRight:'10px', marginTop: '26px' }}>
                        <Slider
                          aria-label="Always visible"
                          defaultValue={ltv}
                          value={ltv}
                          onChange={(event, newValue) => setLtv(newValue)}
                          getAriaValueText={valuetext}
                          step={10}
                          marks={marks}
                          valueLabelDisplay="on"
                          sx={{
                            color: "#ff6b35",
                            "& .MuiSlider-thumb": {
                              backgroundColor: "#ff6b35", 
                              border: "5px solid #ff6b35",
                              borderRadius: '3px'
                            },
                            "& .MuiSlider-thumb:before": {
                              boxShadow: 'none'
                            },
                            "& .MuiSlider-thumb:hover, & .MuiSlider-thumb.Mui-focusVisible": {
                              boxShadow: "0px 0px 0px 8px rgba(248, 156, 123, 0.2)",
                            },
                            "& .MuiSlider-track": {
                              backgroundColor: "#ff6b35",
                              height: '10px'
                            },
                            "& .MuiSlider-rail": {
                              backgroundColor: "#ffffff80",
                              opacity: 1,
                              height: '10px'
                            },
                            "& .MuiSlider-valueLabel": {
                              backgroundColor: "#ff6b35",
                              color: "#fff",
                              borderRadius: "4px",
                            },
                            "& .MuiSlider-mark": {
                              backgroundColor: "#000000ff",
                              width: '5px',
                              height: '8px',
                              borderRadius: '4px'
                            },
                            "& .MuiSlider-markActive": {
                              backgroundColor: "#ff6b35",
                            },
                            "& .MuiSlider-markLabel": {
                              color: "#ffffffff",
                              fontWeight: '600'
                            },
                            "& .MuiSlider-markLabelActive": {
                              color: "#ff6b35",
                            },
                          }}
                        />
                      </Box>
                      {disable === true ? (
                        <div className={`myBtn px-4 py-3 me-2 mt-3 d-inline-block fw-semibold disabled`} style={{textDecoration:'none', cursor:'pointer', fontSize:'14px'}}>NEXT</div>
                      ) : (
                        <Link to="/loansummary" state={{ loan_id: state.loan_id, casset: state.casset, collateral: state.collateral, collat : state.collat, loanasset : loanasset, loan : loan, loanUsd : loanUsd, ltv : ltv, cprice : state.cprice, price : price }} className={`myBtn px-4 py-3 me-2 mt-3 d-inline-block fw-semibold`} style={{textDecoration:'none', cursor:'pointer', fontSize:'14px'}}>NEXT</Link>
                      )
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div claName="col-12">
                <div className="mycard mt-2">
                  <h5 className="fw-bold">Loan History ({user?.currency})</h5>
                  <Bar label={chartData.labels} data={chartData.data}/>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default LoanForm